import { Edit, Trash2, CheckCircle2 } from "lucide-react";

import { ApprovalFlowGetData } from "../model/approvalsFlowModel";

interface ApprovalFlowCardProps {
  flow: ApprovalFlowGetData;
  onEdit: (flow: ApprovalFlowGetData) => void;
  onDelete: (id: string) => void;
  onSetDefault: (id: string) => void;
  onDetails: (id: string) => void;
}

//   flow,
//   onEdit,
//   onDelete,
//   onSetDefault,
//   onDetails,
// }: ApprovalFlowCardProps) => {
//   return (
//     <div className="border rounded-lg p-4 bg-white hover:shadow-md transition-shadow">
//       {/* Header */}
//       <div className="flex items-start justify-between">
//         {/* Title */}
//         <div className="space-y-1">
//           <h3 className="text-sm font-semibold flex items-center gap-2">
//             {flow.name}

//             {flow.is_default && (
//               <span className="px-2 py-0.5 text-xs rounded bg-blue-600 text-white flex items-center gap-1">
//                 <CheckCircle2 className="h-3 w-3" /> Default
//               </span>
//             )}
//           </h3>

//           <p className="text-sm text-gray-500">
//             {flow.total_levels} approval level(s)
//           </p>
//         </div>

//       </div>
//       <div className="mt-4 space-y-2">
//         <div className="flex gap-2">
//           <button
//             className="p-2 border rounded hover:bg-gray-100"
//             onClick={() => onEdit(flow)}
//           >
//             <Edit className="h-4 w-4" />
//           </button>

//           <button
//             className="p-2 border rounded hover:bg-gray-100"
//             onClick={() => onDelete(flow.id)}
//           >
//             <Trash2 className="h-4 w-4 text-red-600" />
//           </button>
//         </div>

//         <button
//           onClick={() => onDetails(flow.id)}
//           className="px-2 py-1.5 bg-white text-blue-600 font-medium rounded-lg hover:bg-white transition-all duration-300 shadow-sm hover:shadow-md flex items-center space-x-2 group/btn float-end"
//         >
//           <span>View Details</span>
//           <svg
//             className="w-4 h-4 transition-transform duration-300 group-hover/btn:translate-x-1"
//             fill="none"
//             stroke="currentColor"
//             viewBox="0 0 24 24"
//           >
//             <path
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               strokeWidth="2"
//               d="M14 5l7 7m0 0l-7 7m7-7H3"
//             />
//           </svg>
//         </button>
//       </div>
//     </div>
//   );
// };
export const ApprovalFlowCard = ({
  flow,
  onEdit,
  onDelete,
  onDetails,
}: ApprovalFlowCardProps) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border p-4 hover:shadow-md transition-shadow">
      <div className="flex  justify-between flex-col">
        {/* LEFT SIDE */}
        <div className="flex gap-4 min-w-0">
          <h3 className="text-sm font-medium text-gray-900  flex items-center gap-2 min-w-0">
            <h3 className="text-sm font-medium text-gray-900 truncate max-w-[300px]">
              {flow.name}
            </h3>
            {flow.is_default && (
              <span className="px-2 py-0.5 text-xs rounded bg-blue-600 text-white flex gap-1 shrink-0">
                <CheckCircle2 className="h-3 w-3" />
                Default
              </span>
            )}
          </h3>
        </div>
        <p className="text-xs text-gray-500 truncate">
           {flow.total_levels} approval level(s)
        </p>
       
        <div className="flex items-center justify-between mt-4">
          {/* LEFT SIDE (Edit + Delete) */}
          <div className="flex items-center gap-4">
            <button
              className="p-2 border rounded-md hover:bg-gray-100 transition"
              onClick={() => onEdit(flow)}
            >
              <Edit className="h-4 w-4" />
            </button>

            <button
              className="p-2 border rounded-md hover:bg-red-50 transition"
              onClick={() => onDelete(flow.id)}
            >
              <Trash2 className="h-4 w-4 text-red-600" />
            </button>
          </div>
          <div>
            <button
              onClick={() => onDetails(flow.id)}
              className="flex-1 text-xs bg-indigo-600 text-white px-2 py-1 rounded hover:bg-indigo-700 w-[10vh]"
            >
              View
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
